export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6">
      <div>
        <h1 className="font-heading font-bold text-2xl md:text-3xl tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="mt-1.5 text-sm text-slate-600 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
